import Vue from "vue";

import BannerCarousel from "./BannerCarousel.vue";

export function load() {
    const selector = "banner-carousel";

  // Is the custom Vue root element in the DOM?
  if (!document.querySelector(selector)) {
    return;
  }

  // Create a new Vue app with the imported Home component
  new Vue({
    render: createElement =>
      createElement(BannerCarousel, {
        props: {
          ...window[selector],
        },
      }),
  }).$mount(selector);
}
